export enum ModuleState {
  InProgress,
  Proficient,
  Failed
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/module-state/module-states.ts